import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { GenericComponent } from "../../components/GenericComponent";
import { PepFamilia } from "../../models/ficha/PepFamilia";
import { PepFichaService } from "../../service/ficha/PepFichaService";
import { useState } from "react";
import { Generico } from "../../components/Generico";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { CatalogoService } from "../../service/CatalogoService";

export const PepFamiliar = ({ tipo, id, toast, permss, opcion, catalogos, version }) => {

    const generic = new GenericComponent();
    const omodel = new PepFamilia();
    const { accionesTbl, estadosSiNo, stringToDate } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const familiaSrv = new PepFichaService();
    const catalogoSrv = new CatalogoService();
    const [ciudades, setCiudades] = useState(null);
    const [registros, setRegistros] = useState(null);
    const [dialogFamiliar, setDialogFamiliar] = useState(false);
    const [familia, setFamilia] = useState(null);
    const [load, setLoad] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [enCargo, setEnCargo] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inDrop, inNumber, inCalendar } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    const editFamiliar = () => {
        familiaSrv.consultarPep(familia?.id, opcion, tipo, id, version).then(res => {
            let _cat = catalogos;
            const lista = { tipo_identificacion: _cat?.tipo };
            let _fam = res.data.familiar;
            if (version > 1) {
                lista.mantiene_cargo = estadosSiNo;
                lista.pais = _cat.pais;
                lista.tipo_cargo = catalogos?.cargo;
                if (res.data.ciudades !== undefined) {
                    lista.ciudad = res.data.ciudades;
                    lista.provincia = _cat.provincias;
                    setCiudades(res.data.ciudades);
                }
                setEcuador(_fam.pais === catalogos.ecuador.cat_id);
                const _enCargo = _fam.mantiene_cargo;
                setEnCargo(_enCargo);

                if (_fam.fecha_inicio) _fam.fecha_inicio = stringToDate(_fam.fecha_inicio);
                if (_fam.fecha_fin && !_enCargo) _fam.fecha_fin = stringToDate(_fam.fecha_fin);
            }

            Object.keys(lista).forEach(function (key) {
                if (_fam[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _fam[key]) {
                            _fam[key] = element;
                        }
                    });
                }
            });

            reset(_fam);
            setDialogFamiliar(true);
        });
    }

    const loadLazyFamiliar = (idp) => {
        setLoading(true);

        let _lazyParams = lazyParams;
        _lazyParams.idp = idp ?? id;
        _lazyParams.tipo = tipo;

        familiaSrv.getPep({ lazyEvent: JSON.stringify(_lazyParams) }, opcion).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.version = version;
        if (version > 1) {
            data.ec = catalogos.ecuador;
            data.fecha_inicio = data.fecha_inicio.toISOString().split('T')[0];
            if (enCargo) {
                delete data.fecha_fin;
            } else {
                data.fecha_fin = data.fecha_fin.toISOString().split('T')[0];
            }
        }
        setLoad(true);
        if (getValues('id') == null) {
            familiaSrv.newPep(data, opcion).then(res => {
                setLoad(false);
                setDialogFamiliar(false);
                loadLazyFamiliar();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                setLoad(false);
                generic.funcError(error, toast, setError);
            });
        }
        else {
            familiaSrv.editarPep(data, opcion).then(res => {
                setDialogFamiliar(false);
                loadLazyFamiliar();
                setLoad(false);
                generic.funcSuccess(res, toast);
            }).catch(error => {
                setLoad(false);
                generic.funcError(error, toast, setError);
            });
        }
    }

    const openNew = () => {
        setFamilia(null);
        setDialogFamiliar(true);
        reset(defaultValues);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteFamilia()
        });
    };

    const deleteFamilia = () => {
        familiaSrv.eliminarPep(familia?.id, opcion, tipo).then(res => {
            loadLazyFamiliar();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && (!familia?.nemonico || familia.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFamiliar() } });
        if (permss?.eliminar && (!familia?.nemonico || familia?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} title="Registrar información"
                        style={{ display: permss?.crear ? 'block' : 'none' }} />
                    <span className="font-bold">Si usted, su cónyuge o conviviente, o familiares cercanos es una Persona Expuesta Políticamente, detalle</span>
                </div>
            </div>
        );
    }

    const onChangePais = (e) => {
        setEcuador(JSON.stringify(e.value) === JSON.stringify(catalogos.ecuador));
    }

    const onChangeProvincia = (e) => {
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const dialogoFamiliar = () => {
        return (
            <Dialog visible={dialogFamiliar} header={getValues('id') == null ? "Nueva Información" : "Editar Información"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogFamiliar(false)} style={{ width: '800px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre_completo', { icon: 'pi pi-user' }, 12)}
                        {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel }, 6)}
                        {inText('identificacion', { icon: 'pi pi-id-card' }, 6)}
                        {inText('parentezco', { icon: 'pi pi-users' }, 6)}

                        {version > 1 && <>
                            {inText('razon_social', { icon: 'pi pi-building' }, 12)}
                            {inText('direccion', { icon: 'pi pi-map-marker' }, 12)}
                            {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, 4)}
                            {ecuador && inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                            {ecuador && inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                            {!ecuador && inText('canton', { icon: 'pi pi-globe' }, 4)}

                            {inText('tipo_relacion', { icon: 'pi pi-th-large' }, 4)}
                            {inDrop('tipo_cargo', catalogos?.cargo, { lab: omodel.optionLabel }, 4)}
                            {inDrop('mantiene_cargo', estadosSiNo, { lab: omodel.optionLabel, chn: onChangeCargo }, 4)}
                            {inCalendar('fecha_inicio', {}, 4)}

                            {enCargo === false && inCalendar('fecha_fin', {}, 4)}
                            {inText('cargo', { icon: 'pi pi-shop' }, 6)}
                            {inNumber('rmu', 2, true, { icon: 'pi pi-money-bill' }, 4)}
                        </>}
                    </div>

                    {generic.buttonsForms(setDialogFamiliar, load)}
                </form>
            </Dialog>
        );
    }

    const tableFamiliar = () => {
        return (
            <Panel headerTemplate={headerTemplate} className="panel-ficha col-12">
                {table({ action01: accionesTbl, reg: setFamilia, items: itemsMenu() })}
            </Panel>
        )
    }

    const onChangeCargo = (e) => {
        let _cargo = false;
        if (e.value) {
            _cargo = e.value?.cat_id;
        }
        setEnCargo(_cargo);
    }

    return {
        tableFamiliar,
        dialogoFamiliar,
        loadLazyFamiliar
    }
}
